var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSideBarFleetOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35.5,
    height: 32.782,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5715 21.4286H3.42868C2.91439 21.4286 2.57153 21.0857 2.57153 20.5714V3.42855C2.57153 2.91427 2.91439 2.57141 3.42868 2.57141H20.5715C21.0858 2.57141 21.4287 2.91427 21.4287 3.42855V20.5714C21.4287 21.0857 21.0858 21.4286 20.5715 21.4286ZM4.28582 19.7143H19.7144V4.2857H4.28582V19.7143Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2857 18C15.7715 18 15.4286 17.6571 15.4286 17.1429V6.85714C15.4286 6.34286 15.7715 6 16.2857 6C16.8 6 17.1429 6.34286 17.1429 6.85714V17.1429C17.1429 17.6571 16.8 18 16.2857 18ZM12 18C11.4857 18 11.1429 17.6571 11.1429 17.1429V13.7143C11.1429 13.2 11.4857 12.8571 12 12.8571C12.5143 12.8571 12.8572 13.2 12.8572 13.7143V17.1429C12.8572 17.6571 12.5143 18 12 18ZM7.71432 18C7.20003 18 6.85718 17.6571 6.85718 17.1429V12C6.85718 11.4857 7.20003 11.1429 7.71432 11.1429C8.22861 11.1429 8.57146 11.4857 8.57146 12V17.1429C8.57146 17.6571 8.22861 18 7.71432 18ZM12 11.1429C11.4857 11.1429 11.1429 10.8 11.1429 10.2857V9.42857C11.1429 8.91429 11.4857 8.57143 12 8.57143C12.5143 8.57143 12.8572 8.91429 12.8572 9.42857V10.2857C12.8572 10.8 12.5143 11.1429 12 11.1429Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBarFleetOverview);
export default __webpack_public_path__ + "static/media/side-bar-fleet-overview.9c7994df291cd1d76e31154d6f08deb0.svg";
export { ForwardRef as ReactComponent };